export default "__VITE_ASSET__C0erWqaO__"